import {CoreBaseEffects} from "@core/core-base.effects";
import {Observable} from "rxjs";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {Injectable} from "@angular/core";
import {
  ISharedNotificationListGetNotificationListPayload,
  setNotificationAllowanceForSubjectSuccess,
} from "@shared/components/notification-list/store/shared-notification-list.actions";
import {SharedNotificationListActions} from "./shared-notification-list.actions-type";

@Injectable({
  providedIn: 'root'
})
export abstract class SharedNotificationListBaseEffects extends CoreBaseEffects {

  protected constructor(store: Store, rawActions$: Actions) {
    super(store, rawActions$);
  }

  abstract getNotificationList(action$: Observable<ISharedNotificationListGetNotificationListPayload>): Observable<any>;

  abstract startNotificationPollingInterval(action$: Observable<any>): Observable<any>;

  abstract stopNotificationPollingInterval(action$: Observable<any>): Observable<any>;

  abstract markAllAsRead(action$: Observable<any>): Observable<any>;

  abstract getNotificationSettings(action$: Observable<any>): Observable<any>;

  abstract setGlobalNotificationAllowance(action$: Observable<any>): Observable<any>;

  abstract setNotificationAllowanceForSubject(action$: Observable<any>): Observable<any>;

  getNotificationList$ = createEffect(() => this.actions().pipe(
    ofType(SharedNotificationListActions.getNotificationList),
    action => this.getNotificationList(action)
  ));

  startNotificationPollingInterval$ = createEffect(() => this.actions().pipe(
    ofType(SharedNotificationListActions.startNotificationPollingInterval),
    action => this.startNotificationPollingInterval(action)
  ))

  stopNotificationPollingInterval$ = createEffect(() => this.actions().pipe(
    ofType(SharedNotificationListActions.stopNotificationPollingInterval),
    action => this.stopNotificationPollingInterval(action)
  ), { dispatch: false })

  markAllAsRead$ = createEffect(()=> this.actions().pipe(
    ofType(SharedNotificationListActions.markAllAsRead),
    action => this.markAllAsRead(action)
  ));

  getNotificationSettings$  = createEffect(()=> this.actions().pipe(
    ofType(SharedNotificationListActions.getNotificationSettings),
    action => this.getNotificationSettings(action)
  ));

  setGlobalNotificationAllowance$ = createEffect(()=> this.actions().pipe(
    ofType(SharedNotificationListActions.setGlobalNotificationAllowance),
    action => this.setGlobalNotificationAllowance(action)
  ));

  setNotificationAllowanceForSubject$ = createEffect(()=> this.actions().pipe(
    ofType(SharedNotificationListActions.setNotificationAllowanceForSubject),
    action => this.setNotificationAllowanceForSubject(action)
  ));
}
